module.exports = __webpack_public_path__ + "components/country-flag/static/im-4d4be225b7e08a0c07fd289ebff2c5a5.svg";